// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"45":"30e1f94b","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"45":"2de07848751ad5a7ee02","245":"8c055d120e8d929b61d3","453":"603eec11b06438395241"}[chunkId] + ".js";
};